/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AdminCompany,
    AdminCompanyFromJSON,
    AdminCompanyToJSON,
    CompanyOffer,
    CompanyOfferFromJSON,
    CompanyOfferToJSON,
    CompanyOfferItemWithCompany,
    CompanyOfferItemWithCompanyFromJSON,
    CompanyOfferItemWithCompanyToJSON,
    DefaultResponse,
    DefaultResponseFromJSON,
    DefaultResponseToJSON,
    InlineResponse2001,
    InlineResponse2001FromJSON,
    InlineResponse2001ToJSON,
    InlineResponse2002,
    InlineResponse2002FromJSON,
    InlineResponse2002ToJSON,
    InlineResponse2003,
    InlineResponse2003FromJSON,
    InlineResponse2003ToJSON,
    Status,
    StatusFromJSON,
    StatusToJSON,
} from '../models';

export interface AdminCompaniesDashboardGetRequest {
    search?: string;
    status?: number;
    completed?: number;
    withOffers?: number;
    withCandidates?: number;
}

export interface AdminCompaniesEditIdPutRequest {
    id: number;
    name?: string;
    nif?: string;
    text?: string;
    contactEmail?: string;
    contactName?: string;
    contactSurname?: string;
    contactPhone?: string;
}

export interface AdminCompaniesExportGetRequest {
    search?: string;
    status?: number;
    completed?: number;
    withOffers?: number;
    withCandidates?: number;
}

export interface AdminCompaniesGetRequest {
    search?: string;
    status?: number;
    completed?: number;
    withOffers?: number;
    withCandidates?: number;
    page?: number;
    limit?: number;
}

export interface AdminCompaniesIdDeleteRequest {
    id: number;
}

export interface AdminCompaniesIdGetRequest {
    id: number;
}

export interface AdminCompaniesIdPutRequest {
    id: number;
    status?: Status;
}

export interface AdminOffersDashboardGetRequest {
    company?: number;
    search?: string;
    status?: number;
    modality?: number;
    city?: number;
    academicProgramScope?: number;
    minimalPublishDate?: string;
}

export interface AdminOffersExportGetRequest {
    company?: number;
    search?: string;
    status?: number;
    modality?: number;
    city?: number;
    academicProgramScope?: number;
    minimalPublishDate?: string;
}

export interface AdminOffersGetRequest {
    company?: number;
    search?: string;
    status?: number;
    modality?: number;
    city?: number;
    academicProgramScope?: number;
    minimalPublishDate?: string;
    page?: number;
    limit?: number;
}

export interface AdminOffersIdGetRequest {
    id: number;
}

/**
 * 
 */
export class AdminApi extends runtime.BaseAPI {

    /**
     * Dashboard info
     */
    async adminCompaniesDashboardGetRaw(requestParameters: AdminCompaniesDashboardGetRequest): Promise<runtime.ApiResponse<InlineResponse2002>> {
        const queryParameters: any = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.completed !== undefined) {
            queryParameters['completed'] = requestParameters.completed;
        }

        if (requestParameters.withOffers !== undefined) {
            queryParameters['with_offers'] = requestParameters.withOffers;
        }

        if (requestParameters.withCandidates !== undefined) {
            queryParameters['with_candidates'] = requestParameters.withCandidates;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/companies/dashboard`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse2002FromJSON(jsonValue));
    }

    /**
     * Dashboard info
     */
    async adminCompaniesDashboardGet(requestParameters: AdminCompaniesDashboardGetRequest): Promise<InlineResponse2002> {
        const response = await this.adminCompaniesDashboardGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Actualizar perfil de empresa
     */
    async adminCompaniesEditIdPutRaw(requestParameters: AdminCompaniesEditIdPutRequest): Promise<runtime.ApiResponse<DefaultResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling adminCompaniesEditIdPut.');
        }

        const queryParameters: any = {};

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.nif !== undefined) {
            queryParameters['nif'] = requestParameters.nif;
        }

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.contactEmail !== undefined) {
            queryParameters['contact_email'] = requestParameters.contactEmail;
        }

        if (requestParameters.contactName !== undefined) {
            queryParameters['contact_name'] = requestParameters.contactName;
        }

        if (requestParameters.contactSurname !== undefined) {
            queryParameters['contact_surname'] = requestParameters.contactSurname;
        }

        if (requestParameters.contactPhone !== undefined) {
            queryParameters['contact_phone'] = requestParameters.contactPhone;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/companies/edit/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DefaultResponseFromJSON(jsonValue));
    }

    /**
     * Actualizar perfil de empresa
     */
    async adminCompaniesEditIdPut(requestParameters: AdminCompaniesEditIdPutRequest): Promise<DefaultResponse> {
        const response = await this.adminCompaniesEditIdPutRaw(requestParameters);
        return await response.value();
    }

    /**
     * Export data
     */
    async adminCompaniesExportGetRaw(requestParameters: AdminCompaniesExportGetRequest): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.completed !== undefined) {
            queryParameters['completed'] = requestParameters.completed;
        }

        if (requestParameters.withOffers !== undefined) {
            queryParameters['with_offers'] = requestParameters.withOffers;
        }

        if (requestParameters.withCandidates !== undefined) {
            queryParameters['with_candidates'] = requestParameters.withCandidates;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/companies/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Export data
     */
    async adminCompaniesExportGet(requestParameters: AdminCompaniesExportGetRequest): Promise<Blob> {
        const response = await this.adminCompaniesExportGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Se llama desde el core, no hay pantalla todavia
     */
    async adminCompaniesGetRaw(requestParameters: AdminCompaniesGetRequest): Promise<runtime.ApiResponse<InlineResponse2001>> {
        const queryParameters: any = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.completed !== undefined) {
            queryParameters['completed'] = requestParameters.completed;
        }

        if (requestParameters.withOffers !== undefined) {
            queryParameters['with_offers'] = requestParameters.withOffers;
        }

        if (requestParameters.withCandidates !== undefined) {
            queryParameters['with_candidates'] = requestParameters.withCandidates;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/companies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse2001FromJSON(jsonValue));
    }

    /**
     * Se llama desde el core, no hay pantalla todavia
     */
    async adminCompaniesGet(requestParameters: AdminCompaniesGetRequest): Promise<InlineResponse2001> {
        const response = await this.adminCompaniesGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Dar de baja / vetar empresa
     */
    async adminCompaniesIdDeleteRaw(requestParameters: AdminCompaniesIdDeleteRequest): Promise<runtime.ApiResponse<DefaultResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling adminCompaniesIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/companies/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DefaultResponseFromJSON(jsonValue));
    }

    /**
     * Dar de baja / vetar empresa
     */
    async adminCompaniesIdDelete(requestParameters: AdminCompaniesIdDeleteRequest): Promise<DefaultResponse> {
        const response = await this.adminCompaniesIdDeleteRaw(requestParameters);
        return await response.value();
    }

    /**
     * Se llama desde el core, no hay pantalla todavia
     */
    async adminCompaniesIdGetRaw(requestParameters: AdminCompaniesIdGetRequest): Promise<runtime.ApiResponse<Array<AdminCompany>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling adminCompaniesIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/companies/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdminCompanyFromJSON));
    }

    /**
     * Se llama desde el core, no hay pantalla todavia
     */
    async adminCompaniesIdGet(requestParameters: AdminCompaniesIdGetRequest): Promise<Array<AdminCompany>> {
        const response = await this.adminCompaniesIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Para cambiar desde core el status de aprovado de la empresa
     */
    async adminCompaniesIdPutRaw(requestParameters: AdminCompaniesIdPutRequest): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling adminCompaniesIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/admin/companies/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StatusToJSON(requestParameters.status),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Para cambiar desde core el status de aprovado de la empresa
     */
    async adminCompaniesIdPut(requestParameters: AdminCompaniesIdPutRequest): Promise<boolean> {
        const response = await this.adminCompaniesIdPutRaw(requestParameters);
        return await response.value();
    }

    /**
     * Dashboard de ofertas
     */
    async adminOffersDashboardGetRaw(requestParameters: AdminOffersDashboardGetRequest): Promise<runtime.ApiResponse<InlineResponse2003>> {
        const queryParameters: any = {};

        if (requestParameters.company !== undefined) {
            queryParameters['company'] = requestParameters.company;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.modality !== undefined) {
            queryParameters['modality'] = requestParameters.modality;
        }

        if (requestParameters.city !== undefined) {
            queryParameters['city'] = requestParameters.city;
        }

        if (requestParameters.academicProgramScope !== undefined) {
            queryParameters['academic_program_scope'] = requestParameters.academicProgramScope;
        }

        if (requestParameters.minimalPublishDate !== undefined) {
            queryParameters['minimal_publish_date'] = requestParameters.minimalPublishDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/offers/dashboard`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse2003FromJSON(jsonValue));
    }

    /**
     * Dashboard de ofertas
     */
    async adminOffersDashboardGet(requestParameters: AdminOffersDashboardGetRequest): Promise<InlineResponse2003> {
        const response = await this.adminOffersDashboardGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Exportacion a excel de ofertas
     */
    async adminOffersExportGetRaw(requestParameters: AdminOffersExportGetRequest): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters.company !== undefined) {
            queryParameters['company'] = requestParameters.company;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.modality !== undefined) {
            queryParameters['modality'] = requestParameters.modality;
        }

        if (requestParameters.city !== undefined) {
            queryParameters['city'] = requestParameters.city;
        }

        if (requestParameters.academicProgramScope !== undefined) {
            queryParameters['academic_program_scope'] = requestParameters.academicProgramScope;
        }

        if (requestParameters.minimalPublishDate !== undefined) {
            queryParameters['minimal_publish_date'] = requestParameters.minimalPublishDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/offers/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Exportacion a excel de ofertas
     */
    async adminOffersExportGet(requestParameters: AdminOffersExportGetRequest): Promise<Blob> {
        const response = await this.adminOffersExportGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * List offers
     */
    async adminOffersGetRaw(requestParameters: AdminOffersGetRequest): Promise<runtime.ApiResponse<Array<CompanyOfferItemWithCompany>>> {
        const queryParameters: any = {};

        if (requestParameters.company !== undefined) {
            queryParameters['company'] = requestParameters.company;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.modality !== undefined) {
            queryParameters['modality'] = requestParameters.modality;
        }

        if (requestParameters.city !== undefined) {
            queryParameters['city'] = requestParameters.city;
        }

        if (requestParameters.academicProgramScope !== undefined) {
            queryParameters['academic_program_scope'] = requestParameters.academicProgramScope;
        }

        if (requestParameters.minimalPublishDate !== undefined) {
            queryParameters['minimal_publish_date'] = requestParameters.minimalPublishDate;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/offers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompanyOfferItemWithCompanyFromJSON));
    }

    /**
     * List offers
     */
    async adminOffersGet(requestParameters: AdminOffersGetRequest): Promise<Array<CompanyOfferItemWithCompany>> {
        const response = await this.adminOffersGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * details of a offer
     */
    async adminOffersIdGetRaw(requestParameters: AdminOffersIdGetRequest): Promise<runtime.ApiResponse<CompanyOffer>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling adminOffersIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/offers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyOfferFromJSON(jsonValue));
    }

    /**
     * details of a offer
     */
    async adminOffersIdGet(requestParameters: AdminOffersIdGetRequest): Promise<CompanyOffer> {
        const response = await this.adminOffersIdGetRaw(requestParameters);
        return await response.value();
    }

}
